import React from "react";
import { Button, Modal } from "react-bootstrap";
import { DeleteWarningIcon, TrashIconOutline } from "../../../../components/ui/icons";
import { useDeleteQuickAlert } from "./useDeleteQuickAlerts";

interface IProps {
  alertId: string;
  alertTitle: string;
  onDeleteSuccess: () => void;
}

const DeleteQuickAlertModal = (props: IProps) => {
  const { alertId, alertTitle, onDeleteSuccess } = props;
  const { handleDeleteButtonClick, showModel, handleClose, handleShow } =
    useDeleteQuickAlert(alertId,onDeleteSuccess);

  return (
    <>
      <div onClick={handleShow} style={{ cursor: "pointer" }}>
        <TrashIconOutline />
      </div>

      <Modal
        show={showModel}
        onHide={handleClose}
        className="modal-container"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="delete-heading">
              <DeleteWarningIcon />
              <h1>Delete Quick Alert</h1>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete <b>{alertTitle}</b> quick alert?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-cancel" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="btn-delete" onClick={handleDeleteButtonClick}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DeleteQuickAlertModal;
